import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { Location } from '../models/app.models';
@Injectable({
  providedIn: 'root'
})
export class LocationService {
  private readonly locationsUrl =
    environment.apiUrl + '/locations';

  constructor(private readonly http: HttpClient) {}

  // Retrieve every active location from the backend.
  getLocations(): Observable<Location[]> {
    return this.http.get<Location[]>(this.locationsUrl);
  }
  // Retrieve active and inactive locations for the Admin Portal.
  getAdminLocations(): Observable<Location[]> {
    return this.http.get<Location[]>(
      this.locationsUrl + '/admin',
      {
        withCredentials: true
      }
    );
  }

  // Create a new location and return the database-created record.
  createLocation(location: Location): Observable<Location> {
    return this.http.post<Location>(
      this.locationsUrl,
      location,
      {
        withCredentials: true
      }
    );
  }

  // Update an existing location and return the saved database record.
  updateLocation(location: Location): Observable<Location> {
    return this.http.put<Location>(
      this.locationsUrl + '/' + location.id,
      location,
      {
        withCredentials: true
      }
    );
  }

  // Permanently delete a location.
  deleteLocation(id: number): Observable<void> {
    return this.http.delete<void>(
      this.locationsUrl + '/' + id,
      {
        withCredentials: true
      }
    );
  }
}